export enum AlertType {
  Info = 1,
  Normal = 2,
  Warning = 3,
  Alert = 4,
  Critical = 5,
  Emergency = 6,
  SystemMaintenance = 7,
  SystemError = 8
}

/**
 * @desc: old alert type on have 1. Info, 2. Error
 */
export enum AlertTypeOld {
  Info = 1,
  Error = 2,
}


export enum AlertMethod {
  Email = 0,
  SMS = 1,
  Push = 2
}

export interface MetadataFieldDTO {
  field?: string | null
  value?: any
  unit?: string | null
}

export interface AlertResponse {
  id: string
  objectId?: string | null
  messageCode?: string | null
  type?: string | null
  tags?: string[] | null
  metadata?: MetadataFieldDTO[] | null
  createdAt: string
}

export interface NotificationSearchParams {
  SortBy?: string
  SortDirection?: string
  ObjectId?: string
  Email?: string
  Tags?: string[]
  Types?: AlertType[]
  PageSize?: number
  PageIndex?: number
  Offset?: number
}

export interface AlertResponsePagedResult {
  page: number
  size: number
  totalPage: number
  totalCount: number
  mobileTotalCount?: number | null
  data?: AlertResponse[] | null
  sort?: string | null
}

export interface CreateNotificationCommand {
  messageCode: string
  type: AlertType
  objectId: string
  scheduledAt?: string
  metadata?: MetadataFieldDTO[]
  tags?: string[]
}

export interface CreateSubscriptionCommand {
  email: string
  phoneNumber?: string
  measure?: string
  language?: string
  tags?: string[]
  method: AlertMethod
  objectId: string
}

export type NotificationResponse = AlertResponsePagedResult
export type NotificationItem = AlertResponse
